// ..\MeDaProWebServiceG2\ITB.MeDaPro.WebService\Models\AttributeDataType.cs
export enum AttributeDataType {
  AttributeDataTypeAlphanumerical = "AttributeDataTypeAlphanumerical",
  AttributeDataTypeNumerical = "AttributeDataTypeNumerical",
  AttributeDataTypeLogical = "AttributeDataTypeLogical",
  AttributeDataTypeInterval = "AttributeDataTypeInterval",
  AttributeDataTypeDate = "AttributeDataTypeDate"
}

export enum ValidationFeedbackType {
  success = "success",
  error = "error",
  warning = "warning"
}

export enum TranslationSetType {
  All,
  OnlyEmpty,
  Selected
}

export enum RuleAction {
  Abort = "Abort",
  SkipValue = "SkipValue",
  KeepValue = "KeepValue"
}

export enum ProgressStatus {
  Queued = "Queued",
  Processing = "Processing",
  Completed = "Completed",
  Faulted = "Faulted",
  Cancelled = "Cancelled",
  CompletedWithError = "CompletedWithError"
}

export enum ProgressType {
  Export = "exports",
  Import = "imports"
}

export enum EmailAuthType {
  None = "None",
  Basic = "Basic",
  OAuth = "OAuth"
}

export enum ResponseStatus {
  Error = "Error",
  Info = "Info",
  Success = "Success"
}
